// extracted by mini-css-extract-plugin
export default {"pillTab":"MainTabs_pillTab__lkUct","scrollableX":"MainTabs_scrollableX__YEbzz","disabled":"MainTabs_disabled__JLqPB","animationRoll":"MainTabs_animationRoll__a9Pqk"};